import process from "prop-types/prop-types";
import React, { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import useSWR from "swr";

import FullScreenLoader from "../../component/FullScreenLoader";
import { getToken, removeToken } from "../../lib/authentication";
import { auth_fetcher } from "../../lib/fetcher";

const Evaluation = React.lazy(() => import("./evaluation"));
const AddTeacherInfo = React.lazy(() => import("./addTeacherInfo"));
const DashboardHome = React.lazy(() => import("./home"));
const NewSurvey = React.lazy(() => import("./newSurvey"));
const TanList = React.lazy(() => import("./tanList"));

export default function DashboardRouter() {
  const token = getToken();
  const navigate = useNavigate();
  if (!token) navigate("/anmelden");

  const {
    data,
    error,
    mutate: updateUser,
  } = useSWR(`${process.env.REACT_APP_BASE_URL}users/me`, auth_fetcher);

  useEffect(() => {
    if (data && !data["teacher"]) {
      navigate("/dashboard/signup", { replace: true });
    }
  }, [navigate, data]);

  if (error)
    if (error.response.status === 401) {
      removeToken();
      navigate("/anmelden");
    } else {
      return <div>failed to load</div>;
    }
  if (!data) return <FullScreenLoader />;

  return (
    <Routes>
      <Route index element={<DashboardHome user={data} />} />
      <Route
        path={"signup"}
        element={<AddTeacherInfo user={data} updateFunction={updateUser} />}
      />
      <Route path={"neue-umfrage"} element={<NewSurvey user={data} />} />
      <Route
        path={"teilnahmeliste/:surveyId"}
        element={<TanList user={data} />}
      />
      <Route
        path={"auswertung/:surveyId"}
        element={<Evaluation user={data} />}
      />
    </Routes>
  );
}
